import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
  selector: 'unauthorized',
  templateUrl: './unauthorized.component.html',
  standalone: false,
})
export class UnauthorizedComponent implements OnInit {
  constructor(private router: Router,
     private titleService: Title
  ) {}

  ngOnInit(): void {
    this.titleService.setTitle('No autorizado');
  }

  goBack() {
    this.router.navigate(['/']);
  }
}
